/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Api_Errors_Geen_SchooldagInputs */

const nl_planning_api_errors_geen_schooldag = /** @type {(inputs: Planning_Api_Errors_Geen_SchooldagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessen plan je alleen op schooldagen, van maandag tot en met vrijdag.`)
};

/**

* @param {Planning_Api_Errors_Geen_SchooldagInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_api_errors_geen_schooldag = /** @type {((inputs?: Planning_Api_Errors_Geen_SchooldagInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Api_Errors_Geen_SchooldagInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_api_errors_geen_schooldag(inputs)
});
export { planning_api_errors_geen_schooldag as "planning.api_errors.geen_schooldag" }